export * from './firebase.app.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// D:/www/kh_indesso_web/~/angularfire2/app/index.js
// module id = ../../../../angularfire2/app/index.js
// module chunks = 4